var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound33AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 36,
  r: 7,
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M21.765 13h1.764v10a2.219 2.219 0 0 1-2.215-2.349l.45-7.651ZM38.236 13H36.47v10a2.219 2.219 0 0 0 2.215-2.349L38.236 13ZM23.529 13H36.47v10H23.529z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M38.824 13H21.177"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 31v10l-8.274.752A2.5 2.5 0 0 1 43 39.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L54 31Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m52 30 .445.223A2.813 2.813 0 0 1 54 32.738v6.524c0 1.065-.602 2.039-1.555 2.515L52 42"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 41V31l8.274-.752A2.5 2.5 0 0 1 17 32.738v6.524a2.5 2.5 0 0 1-2.726 2.49L6 41Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8 42-.445-.223A2.813 2.813 0 0 1 6 39.262v-6.524c0-1.065.602-2.039 1.555-2.515L8 30"
})));
SvgRound33AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound33AError);
export default ForwardRef;